import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TextInput,
  Button,
  Spinner,
} from "flowbite-react";
import { ArrowRight, ArrowLeft ,Eye, ShieldX ,PlusCircle,MinusCircle ,BellDot} from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const NotificationsPage = () => {
  const [user,setUser] = useState(null)
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [limit] = useState(10);
  const navigate = useNavigate();

const fetchUser = async () => {
  try {
 const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
        { withCredentials: true }
      );
      setUser(response.data.user)
  }
  catch(error) {
    console.log(error)
  }
  
}

  const fetchNotifications = async (page = 1, search = "") => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}relatedNotifications/?page=${page}&limit=${limit}&search=${search}`,
        { withCredentials: true }
      );
      setNotifications(response.data.data);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.currentPage);
      setTotalNotifications(response.data.total);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

const markAsRead = async(notificationID)=> {
try {
 const response = await axios.put( `${process.env.REACT_APP_BACKEND_URL}notifications/${notificationID}/read`,{},{
  withCredentials:true
 })
 console.log(response)
 fetchNotifications()
 navigate("/transactionsPage")
}
catch(error) {
  console.log(error)
}
}
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };


  useEffect(() => {
    fetchUser();
    const delayDebounceFn = setTimeout(() => {
      fetchNotifications(currentPage, searchTerm);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, currentPage, navigate]);

  return (
    <section className=" dark:bg-gray-900 w-full flex flex-col gap-3 mt-4">
      <div className="grid w-full grid-cols-1">
        <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
          <div className="w-full sm:w-1/2 p-2">
            <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
              Mes Notifications
            </span>
          </div>
          <div className="w-full sm:w-1/2 p-2">
            <TextInput
              type="text"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="overflow-x-auto rounded-md">
        <Table striped>
          <TableHead>
            <TableHeadCell>Type</TableHeadCell>
            <TableHeadCell>De</TableHeadCell>
            <TableHeadCell>A</TableHeadCell>
            <TableHeadCell>Message</TableHeadCell>
            <TableHeadCell>Date</TableHeadCell>
           {<TableHeadCell>Actions</TableHeadCell>}
          </TableHead>

          <TableBody className="divide-y">
            {notifications?.length ? (
              notifications?.map((notification) => (
                <TableRow
                  key={notification._id}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 text-xs
                  font-bold "
                >
                  <TableCell className={`flex flex-row  gap-1  ${
                      notification.type === "affectation"
                        ? "text-green-500"
                        : notification.type === "recouvrement"
                        ? "text-red-500"
                        : "text-orange-500"
                    } mt-2`}>
                      { notification.type === "affectation" ? <PlusCircle size={16}/> : <MinusCircle size={16}/>}
                     <span>{notification?.type?.toUpperCase()}</span> 
                      </TableCell>
                
                  <TableCell>{notification.sender?.username}</TableCell>
                  <TableCell>{notification.recipient?.username}</TableCell>
                  <TableCell>{notification.message}</TableCell>
                  <TableCell>
                    {new Date(notification.createdAt).toLocaleDateString()}
                  </TableCell>
                 {user?._id === notification?.recipient?._id&&<TableCell>
                    <div className="flex gap-1">
                      {notification.read !== true &&<Button
                        pill
                        size="xs"
                        // color={"dark"}
                        title="Marquer comme lu"
                        onClick={()=>markAsRead(notification?._id)}
                       >
                        <Eye size={16} className="text-green-500" />
                      </Button>}
                      {false &&<Button
                        pill
                        size="xs"
                        color={"dark"}
                        title="Supprimer"
                       >
                        <ShieldX size={14} className="text-red-400" />
                      </Button>}
                    </div>
                  </TableCell>}
                </TableRow>
              ))
            ) : (
              <TableRow className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300">
                <TableCell>
                  {" "}
                  {loading ? <Spinner /> : "Aucune notification trouvée ."}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
        <div className="flex justify-center items-center gap-2">
          <Button
            disabled={currentPage === 1 || totalPages === 0}
            onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
            color={"dark"}
            size="xs"
          >
            <ArrowLeft size={16} />
          </Button>
          <span className="self-center">
            Page {currentPage} / {totalPages}
          </span>
          <Button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() =>
              setCurrentPage((prev) => Math.min(totalPages, prev + 1))
            }
            color={"dark"}
            size="xs"
          >
            <ArrowRight size={16} />
          </Button>
        </div>
        <div>
          <span>Total : {totalNotifications}</span>
        </div>
      </section>
    </section>
  );
};

export default NotificationsPage;
